export default __webpack_public_path__ + "static/media/114_mobile.8e25d9dc.jpg";